import { Anchor, Box, Button, Text } from '@zillow/constellation-10';
import { IconArrowRightOutline } from '@zillow/constellation-icons';

const Transferred = ({
  onSearchByOtherContactMethodsClick,
  onViewPropertiesClick,
}: {
  onSearchByOtherContactMethodsClick: () => void;
  onViewPropertiesClick: () => void;
}) => (
  <>
    <Box
      css={{ display: 'flex', flexDirection: 'column', alignSelf: 'center', marginBlock: '1200', maxWidth: '450px' }}
    >
      <Text>
        Next, you can view your properties in Zillow Rental Manager. You’ll be able to edit and publish the listing for
        each property individually.
      </Text>
      <br />
      <Text>
        To transfer more listings,{' '}
        <Anchor onClick={onSearchByOtherContactMethodsClick} css={{ fontWeight: '600' }}>
          search by other contact methods.
        </Anchor>
      </Text>
    </Box>
    <Button
      tone="brand"
      emphasis="filled"
      onClick={onViewPropertiesClick}
      icon={<IconArrowRightOutline />}
      iconPosition="end"
      css={{ animation: 'fadeIn ease 2s' }}
    >
      View properties
    </Button>
  </>
);

export default Transferred;
